import React from "react";
import { useEffect } from "react";
import { alergenosEnum } from '../interface/alergenos';
import { IItemInterface, IMenuInterface } from "./dataInterface";

//const ImageHost = "http://gruposina.net/static/";
const ImageHost = "https://static.enjoysushi.es/";
export const menu: IMenuInterface[] = 
[
    {
        'category': 'Entrante',
        'items': [
            {
                'indicator': 1,
                'name': 'Sopa de Miso',
                'description': 'Tofu, algas y miso',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/1.Sopa-de-miso-1-scaled-370x370.jpg',
                'image': ImageHost + 'assert/salad/sopa-miso.webp',
                'alergenos': [
                    alergenosEnum.soja
                ], 
                'picante': false
            },
            /*{
                'indicator': 2,
                'name': 'Ramen Style',
                'description': 'Ramen en caldo con algas, huevos, surimi de cangrejo y gambas',
                'image': ImageHost + 'assert/salad/sopa-ramen.png',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.moluscos,
                    alergenosEnum.huevos,
                    alergenosEnum.cacahuetes
                ], 
                'picante': false
            },
            */
            {
                'indicator': 3,
                'name': 'Edamame',
                'description': 'Vainas de soja',
                'image': ImageHost + 'assert/imagenew/salad/edamame.webp',
                'alergenos': [
                    alergenosEnum.soja
                ], 
                'picante': false
            },
            {
                'indicator': 4,
                'name': 'Ensalada Wakame',
                'description': 'Algas japonesas',
                'image': ImageHost + 'assert/imagenew/salad/salad-alga.webp',
                'alergenos': [
                    alergenosEnum.sesamo
                ], 
                'picante': false
            },
            {
                'indicator': 5,
                'name': 'Ensalada Marisco',
                'description': 'Ensalada de marisco Sunomo',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/10-Ensalada-mariscos-2-scaled-370x370.jpg',
                'image': ImageHost + 'assert/imagenew/salad/salad-marisco.webp',
                'alergenos': [
                    alergenosEnum.sesamo, 
                    alergenosEnum.crustaceos,
                    alergenosEnum.pescado,
                    alergenosEnum.moluscos
                ], 
                'picante': false
            },
            {
                'indicator': 6,
                'name': 'Ensalada Mixta',
                'description': 'Ensalada de mixta de la casa',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/07-Ensalada-KYOKA-2-scaled-370x370.jpg',
                'image': ImageHost + 'assert/imagenew/salad/salad-mixta.webp',
                'alergenos': [
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten,
                    alergenosEnum.altramuz
                ], 
                'picante': false
            },
            {
                'indicator': 7,
                'name': 'Ensalada de Pulpo',
                'description': 'Ensalada de Pulpo con rucula',
                'image': ImageHost + 'assert/imagenew/salad/salad-pulpo.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.moluscos,
                    alergenosEnum.cacahuetes
                ], 
                'picante': false
            },
            {
                'indicator': 8,
                'name': 'Ensalada de Pollo Katsu',
                'description': 'Ensalada con pollo katsu, mezcla de brotes tiernos, mayonesa japonesa y pimientos picados.',
                'image': ImageHost + 'assert/imagenew/salad/pollo-katsu.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.moluscos,
                    alergenosEnum.cacahuetes
                ], 
                'picante': false
            },                
            {
                'indicator': 10,
                'name': 'Bao Pollo Teriyaki',
                'description': 'Bao con pollo, tomate, lechuga y salsa teriyaki',
                //'image': 'https://www.sushitake.eu/wp-content/uploads/2019/06/168-Bao-Pollo-Teriyaki-370.jpg',
                'image': ImageHost + 'assert/imagenew/bao/pollo.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.sesamo
                ], 
                'picante': false
            },
            /*{
                'indicator': 11,
                'name': 'Bao Lomo Cerdo Teriyaki',
                'description': 'Bao con lomo de cerdo, tomate, lechuga y salsa teriyaki',
                'image': ImageHost + 'assert/imagenew/bao/lomo.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.sesamo
                ], 
                'picante': false
            },
            {
                'indicator': 12,
                'name': 'Bao Salmón Teriyaki',
                'description': 'Bao con Salmón, tomate, lechuga y salsa teriyaki',
                'image': ImageHost + 'assert/imagenew/bao/salmon.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.sesamo
                ], 
                'picante': false
            },*/
            {
                'indicator': 20,
                'name': 'Poke Salmón',
                'description': 'Arroz, Salmón, edamame, aguacate, tomate, maiz, pepino, salsa Mango',
                'image': ImageHost + 'assert/imagenew/poke/salmon.webp',
                'alergenos': [
                    alergenosEnum.pescado, 
                    alergenosEnum.sesamo
                ], 
                'picante': false
            },
            {
                'indicator': 21,
                'name': 'Poke Atún',
                'description': 'Arroz, Atún, edamame, aguacate, tomate, maiz, pepino, salsa Mayonesa',
                'image': ImageHost + 'assert/imagenew/poke/atun.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.huevos,
                    alergenosEnum.sesamo
                ], 
                'picante': false
            },
            {
                'indicator': 22,
                'name': 'Poke Pollo Katch',
                'description': 'Arroz, Pollo al estilo Katch, edamame, aguacate, tomate, maiz, pepino, salsa teriyaki y mayonesa japonesa',
                'image': ImageHost + 'assert/imagenew/poke/poke-pollo.webp',
                'alergenos': [
                    alergenosEnum.huevos, 
                    alergenosEnum.gluten,
                    alergenosEnum.sesamo
                ], 
                'picante': false
            },
            {
                'indicator': 23,
                'name': 'Poke Vegetal',
                'description': 'Arroz, edamame, aguacate, cebolla, tomate, maiz, pepino, salsa goma dressing',
                'image': ImageHost + 'assert/poke/vegetal.png',
                'alergenos': [
                    alergenosEnum.sesamo,
                ], 
                'picante': false
            },
            {
                'indicator': 30,
                'name': 'Carpaccio atún',
                'description': 'atún en carpaccio con salsa ponzo y sesamo',
                'image': ImageHost + 'assert/imagenew/carpaccio/atun.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'limit': '*2 ración/pers.'
            },
            {
                'indicator': 31,
                'name': 'Carpaccio salmón',
                'description': 'salmón en carpaccio con salsa ponzo y sesamo',
                'image': ImageHost + 'assert/imagenew/carpaccio/salmon.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'limit': '*2 ración/pers.'
            },
            /*{
                'indicator': 32,
                'name': 'Carpaccio gambón',
                'description': 'gambón en carpaccio con salsa ponzo y sesamo',
                'image': ImageHost + 'assert/picture_icon_BLACK.svg',
                'alergenos': [
                    alergenosEnum.moluscos,
                    alergenosEnum.sesamo,
                ], 
                'picante': false
            },
            */
            {
                'indicator': 33,
                'name': 'Carpaccio mixto',
                'description': 'atún, salmón y lubina en carpaccio con salsa ponzo y sesamo',
                'image': ImageHost + 'assert/imagenew/carpaccio/mixto.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'limit': '*1 ración/pers.'
            }, 
            {
                'indicator': 34,
                'name': 'Ceviche Gambón',
                'description': 'Cebolla roja, aguacate, zumo limón, kimochi y cilandro',
                'image': ImageHost + 'assert/imagenew/ceviche/gambon.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                ], 
                'picante': false
            },
            {
                'indicator': 35,
                'name': 'Ceviche Lubina',
                'description': 'Cebolla roja, aguacate, zumo limón, kimochi y cilandro',
                'image': ImageHost + 'assert/imagenew/ceviche/lubina.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                ], 
                'picante': false
            },
            {
                'indicator': 36,
                'name': 'Chirashi atún spicy',
                'description': 'Arroz, atún, aguacate, kimochi',
                'image': ImageHost + 'assert/chirashi/atun.png',
                'alergenos': [
                    alergenosEnum.pescado,
                ], 
                'picante': false
            },
            {
                'indicator': 37,
                'name': 'Chirashi salmón spicy',
                'description': 'Arroz, salmón, aguacate, kimochi',
                'image': ImageHost + 'assert/chirashi/salmon.png',
                'alergenos': [
                    alergenosEnum.pescado,
                ], 
                'picante': false
            },                                                                                     
        ],
    },
    {
        'category': 'Sushi',
        'items': [
            {
                'indicator': 40,
                'name': 'Nigiri de Salmón',
                'description': 'Nigiri de Salmón (2 Unid.)',
                'image': ImageHost + 'assert/imagenew/nigiri/salmon.webp',
                'alergenos': [
                    alergenosEnum.pescado
                ], 
                'picante': false,
                'subcategory': 'nigiri'
            },
            {
                'indicator': 41,
                'name': 'Nigiri de Atún',
                'description': 'Nigiri de Atún (2 Unid.)',
                'image': ImageHost + 'assert/imagenew/nigiri/atun.webp',
                'alergenos': [
                    alergenosEnum.pescado
                ], 
                'picante': false,
                'subcategory': 'nigiri'
            },                        
            {
                'indicator': 42,
                'name': 'Nigiri de Dorada/Lubina',
                'description': 'Nigiri de Dorada/Lubina (2 Unid.)',
                'image': ImageHost + 'assert/imagenew/nigiri/lubina.webp',
                'alergenos': [
                    alergenosEnum.pescado
                ], 
                'picante': false,
                'subcategory': 'nigiri'
            },
            {
                'indicator': 43,
                'name': 'Nigiri de Gambas',
                'description': 'Nigiri de Gambas (2 Unid.)',
                'image': ImageHost + 'assert/imagenew/nigiri/gamba.webp',
                'alergenos': [
                    alergenosEnum.moluscos
                ], 
                'picante': false,
                'subcategory': 'nigiri'
            },
            {
                'indicator': 44,
                'name': 'Nigiri de Salmón flambeado',
                'description': 'Nigiri de Salmón flambeado, almendra, Salsa Teriyaki (2 Unid.)',
                'image': ImageHost + 'assert/imagenew/nigiri/salmon-flambeado.webp',
                'alergenos': [
                    alergenosEnum.pescado, 
                    alergenosEnum.altramuz,
                    alergenosEnum.soja
                ], 
                'picante': false,
                'subcategory': 'nigiri'
            },
            {
                'indicator': 45,
                'name': 'Nigiri de Atún flambeado',
                'description': 'Nigiri de Atún flambeado, pistacho, Salsa de Mango (2 Unid.)',
                'image': ImageHost + 'assert/imagenew/nigiri/atun-flambeado.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.altramuz
                ], 
                'picante': false,
                'subcategory': 'nigiri'
            },
            {
                'indicator': 46,
                'name': 'Nigiri de Aguacate',
                'description': 'Nigiri de Aguacate (2 Unid.)',
                'image': ImageHost + 'assert/imagenew/nigiri/aguacate.webp',
                'alergenos': [
                ], 
                'picante': false,
                'subcategory': 'nigiri'
            },            
            {
                'indicator': 50,
                'name': 'HosoMaki de Salmón',
                'description': '',
                'image': ImageHost + 'assert/hosomaki/salmon.png',
                'alergenos': [                    
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'subcategory': 'maki'
            },  
            {
                'indicator': 51,
                'name': 'HosoMaki de Atún',
                'description': '',
                'image': ImageHost + 'assert/hosomaki/atun.png',
                'alergenos': [
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'subcategory': 'maki'
            },
            {
                'indicator': 52,
                'name': 'HosoMaki de Pepino',
                'description': '',
                'image': ImageHost + 'assert/hosomaki/pepino.png',
                'alergenos': [
                ], 
                'picante': false,
                'subcategory': 'maki'
            },
            {
                'indicator': 53,
                'name': 'HosoMaki de Aguacate',
                'description': '',
                'image': ImageHost + 'assert/hosomaki/aguacate.png',
                'alergenos': [                    
                ], 
                'picante': false,
                'subcategory': 'maki'
            },
            {
                'indicator': 54,
                'name': 'Sashimi de Salmón',
                'description': 'Sashimi de Salmón (4 Unid.)',
                'image': ImageHost + 'assert/sashimi/salmon.png',
                'alergenos': [
                    alergenosEnum.pescado
                ], 
                'picante': false,
                'limit': '*2 ración/pers.',
                'subcategory': 'sashimi'
            },
            {
                'indicator': 55,
                'name': 'Sashimi de Atún',
                'description': 'Sashimi de Atún (4 Unid.)',
                'image': ImageHost + 'assert/sashimi/atun.png',
                'alergenos': [
                    alergenosEnum.pescado
                ], 
                'picante': false,
                'limit': '*2 ración/pers.',
                'subcategory': 'sashimi'
            },
            {
                'indicator': 56,
                'name': 'Sashimi Mixto',
                'description': 'Sashimi de Atún (2 Unid.) y Salmón (2 Unid.)',
                'image': ImageHost + 'assert/sashimi/mixto.png',
                'alergenos': [
                    alergenosEnum.pescado
                ], 
                'picante': false,
                'limit': '*1 ración/pers.',
                'subcategory': 'sashimi'
            },
            {
                'indicator': 57,
                'name': 'Combo Special de la casa',
                'description': 'Combinación de sushi mixto de la casa compuesto por: Nigiri (Gamba, Salmón, Atún, Dorada/Lubina), Sashimi (Salmón, Atún), HosoMaki (Salmón, Atún) y Urumaki (Salmónm, Aguacate, Cebolla con Salsa Teriyaki y Salsa Mayonesa Japonesa)',
                'image': ImageHost + 'assert/other/sushi-variado.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.gluten
                ], 
                'picante': false,
                'subcategory': 'combo'
            },
            {
                'indicator': 60,
                'name': 'City Roll',
                'description': 'Salmón, aguacate, queso, sesamo, boniato crujiente, salsa Golf (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/city-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 61,
                'name': 'Salmón Mango Roll',
                'description': 'Salmón, mango, queso philadelphia, pistacho, salsa mango y salsa teriyaki. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/salmon-mango-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 62,
                'name': 'Crazy Salmón Roll',
                'description': 'Salmón cocido, mayonesa, cebolla crujiente con salsa teriyaki y mayonesa spicy (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/crazy-salmon-correct.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': true,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 63,
                'name': 'Salmón Roll',
                'description': 'Salmón, aguacate, mayonesa, masago y salsa crema chile dulce (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/salmon-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 64,
                'name': 'Spicy Salmón Roll',
                'description': 'Salmón, pepino, shimichi, salsa siracha y mayonesa (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/spicy-salmon-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': true,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 65,
                'name': 'Salmón Plus Roll',
                'description': 'Salmón, aguacate, envuelto salmon con pistacho y con salsa de crema de chile dulce (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/salmon-plus-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': true,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 66,
                'name': 'Miura Rolls',
                'description': 'Salmón a la plancha, philadelphia, sesamo y cobertura de hojas de almendras (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/miura-rolls.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': true,
                'subcategory': 'uramaki'
            }, 
            {
                'indicator': 67,
                'name': 'Special Rolls',
                'description': 'Salmón, aguacate, philadelphia envuelto de salmón (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/special-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': true,
                'subcategory': 'uramaki'
            },                       
            {
                'indicator': 70,
                'name': 'Crazy Maguro Roll',
                'description': 'Atún Cocido, cebolla crujiente, salsa teriyaki y mayonesa japones (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/crazy-atun-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 71,
                'name': 'Spicy Maguro Roll',
                'description': 'Atún, cebollino, shimichi, salsa siracha y mayonesa (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/spicy-atun-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': true,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 72,
                'name': 'Maguro Aguacate Roll',
                'description': 'Atún, aguacate, sesamo ume, boniato crujiente y salsa crema chile dulce (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/maguro-aguacate-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 73,
                'name': 'Fuji Roll',
                'description': 'Ebi, tempura, aguacate, pollo crujiente, semillas de sésamo, salsa teriyaki y mayonesa spicy (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/fuji-roll.webp',
                'alergenos': [
                    alergenosEnum.moluscos,
                    alergenosEnum.sesamo,
                    alergenosEnum.gluten
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },                        
            {
                'indicator': 80,
                'name': 'Ebi Dragon Roll',
                'description': 'Ebi fry (gamba frita), aguacate, pimiento, salsa teriyaki y mayonesa spicy (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/ebi-dragon-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.moluscos,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },            
            {
                'indicator': 81,
                'name': 'Ebi Power Roll',
                'description': 'Ebi fry (gamba frita), salmón flameado, piztacho, salsa mostaza (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/ebi-power-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.moluscos,
                    alergenosEnum.sesamo,
                    alergenosEnum.frutos_secos
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 82,
                'name': 'Ebi Tiger Roll',
                'description': 'Ebi fry (gamba frita), atún, almendra, salsa teriyaki y mayonesa spicy (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/ebi-tiger-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.moluscos,
                    alergenosEnum.sesamo,
                    alergenosEnum.gluten,
                    alergenosEnum.huevos,
                    alergenosEnum.altramuz
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            }, 
            {
                'indicator': 83,
                'name': 'Ebi Cheese Roll',
                'description': 'Ebi fry (gamba frita), crema queso, kataifi, salsa mango (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/ebi-cheese-roll.webp',
                'alergenos': [
                    alergenosEnum.moluscos,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 84,
                'name': 'Ebi kiss Roll',
                'description': 'Ebi fry (gamba frita), masago, sesamo, salsa Golf (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/ebi-kiss-roll-bis.webp',
                'alergenos': [
                    alergenosEnum.moluscos,
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 85,
                'name': 'Crispy Ebiten Roll',
                'description': 'Ebi fry (gamba frita), cebolla crujiente, salsa mayonesa y salsa teriyaki (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/crispy-ebiten-roll.webp',
                'alergenos': [
                    alergenosEnum.moluscos,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },            
            {
                'indicator': 90,
                'name': 'Black Doble Salmón',
                'description': 'Arroz oscuro, salmón, queso cubierto de salmón, masago, sesamo, salsa cremosa chile dulce. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/black-doble-roll-bis.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 91,
                'name': 'Black Salmón Roll',
                'description': 'Arroz oscuro, salmón cocido, aguacate, boniato crujiente, salsa de teriyaki y mayohensa japonesa. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/black-salmon-roll-bis.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 92,
                'name': 'Black EbiTen',
                'description': 'Arroz oscuro, ebi fry, kataifi y salsa teriyaki. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/black-ebiten.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 93,
                'name': 'Black Tiger Roll',
                'description': 'Arroz oscuro, atún, mayonesa cubierto de salmón flambeado con masago y salsa teriyaki. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/black-tiger-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 94,
                'name': 'Just Vegetal',
                'description': 'Pepino, aguacate, esparragos cocido, zanahoria y salsa yogur. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/vegetal.webp',
                'alergenos': [
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 95,
                'name': 'Chicken Roll',
                'description': 'Pollo frito, aguacate, lechuga, crema queso, cebolla crujiente con salsa teriyaki. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/pollo-roll.webp',
                'alergenos': [
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 96,
                'name': 'Fresh Roll',
                'description': 'Brotes tiernos, pepino, aguacate, espárragos, tomate, pollo en tempura (4 Piezas)',
                'image': ImageHost + 'assert/uramaki/fresh-roll.webp',
                'alergenos': [
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },            
            {
                'indicator': 100,
                'name': 'Special Pekin Roll',
                'description': 'Pato, pepino, cebollino, cebolla crujiente, salsa teriyaki. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/special-pekin-roll.webp',
                'alergenos': [
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 101,
                'name': 'Special Rainbow Roll',
                'description': 'Surimi, aguacate, pepino, cubierto de salmón, aguacate y atún con salsa teriyaki. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/special-rainbow-roll.webp',
                'alergenos': [
                    alergenosEnum.sesamo,
                    alergenosEnum.crustaceos
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 102,
                'name': 'Special Mexico Roll',
                'description': 'Aguacate, queso cremoso, tomate seco, nacho y salsa mayonesa spicy (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/special-mexico-roll.webp',
                'alergenos': [
                    alergenosEnum.sesamo,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 103,
                'name': 'Special Foie Roll',
                'description': 'Foie, manzana, mango con salsa vino.  (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/special-foie-roll.webp',
                'alergenos': [
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            }, 
            {
                'indicator': 104,
                'name': 'Special Ten Plus',
                'description': 'Salmón. aguacate, queso cremoso, salmón ahumado, kataifi, salsa teriyaki con mayonesa. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/special-ten-plus-correct.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },     
            /*{
                'indicator': 105,
                'name': 'Special Cheese Roll',
                'description': 'Aguacate, surimi, salsa cheese flameado. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/special-cheese-roll.webp',
                'alergenos': [
                    alergenosEnum.crustaceos,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },*/
            {
                'indicator': 106,
                'name': 'Special Verde Roll',
                'description': 'Papel de arroz, lechuga, salmón, aguacate y salsa yogur. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/special-verde-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },
            {
                'indicator': 107,
                'name': 'Tasty Salmón Roll',
                'description': 'Salmón flambeado, fresa, aguacate, queso crema y salsa mayo japonesa. (8 Piezas)',
                'image': ImageHost + 'assert/uramaki/tasty-salmon-roll.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.lacteos
                ], 
                'picante': false,
                'subcategory': 'uramaki'
            },            
            {
                'indicator': 110,
                'name': 'Futo ebiten',
                'description': 'Ebi fly con salsa de mango y cebolla crujiente y salsa teriyaki. (4 Piezas)',
                'image': ImageHost + 'assert/makifry/futo-ebiten.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.huevos
                ], 
                'picante': false,
                'subcategory': 'hosofrito'
            },
            {
                'indicator': 111,
                'name': 'Hosofrito Vegetal',
                'description': 'Aguacate, wakame y salsa yogur. (4 Piezas)',
                'image': ImageHost + 'assert/makifry/vegetal.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.crustaceos,
                    alergenosEnum.huevos
                ], 
                'picante': false,
                'subcategory': 'hosofrito'
            },  
            {
                'indicator': 112,
                'name': 'Hosofrito Salmón.',
                'description': 'Salmón, salsa crema queso y pistacho.  (4 Piezas)',
                'image': ImageHost + 'assert/makifry/salmon.webp',
                'alergenos': [
                ], 
                'picante': false,
                'subcategory': 'hosofrito'
            },
            {
                'indicator': 113,
                'name': 'Hosofrito Surf',
                'description': 'Salmón, tartar de salmón spicy, boniate crujiente y salsa teriyaki.  (4 Piezas)',
                'image': ImageHost + 'assert/makifry/surf.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.gluten
                ], 
                'picante': true,
                'subcategory': 'hosofrito'
            }, 
            {
                'indicator': 140,
                'name': 'Gunkan Atún (2 Unid.)',
                'description': 'Arroz envuelto de alganori, tobiko, mayonesa, tabasco.',
                'image': ImageHost + 'assert/imagenew/gunkan/atun.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.huevos
                ], 
                'picante': true,
                'subcategory': 'gunkan'                
            },
            {
                'indicator': 141,
                'name': 'Gunkan Salmón (2 Unid.)',
                'description': 'Arroz envuelto de alganori, tobiko, mayonesa, tabasco.',
                'image': ImageHost + 'assert/imagenew/gunkan/salmon.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.huevos
                ], 
                'picante': true,
                'subcategory': 'gunkan'  
            },                                                                                                                                                                                                                                                   
            {
                'indicator': 142,
                'name': 'Gunkan doble Atún (2 Unid.)',
                'description': 'Arroz envuelto de atún, tobiko, mayonesa, tabasco.',
                'image': ImageHost + 'assert/imagenew/gunkan/doble-atun.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.huevos
                ], 
                'picante': true,
                'subcategory': 'gunkan'  
            },
            {
                'indicator': 143,
                'name': 'Gunkan doble Salmón (2 Unid.)',
                'description': 'Arroz envuelto de salmón, tobiko, mayonesa, tabasco.',
                'image': ImageHost + 'assert/imagenew/gunkan/doble-salmon.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.huevos
                ], 
                'picante': true,
                'subcategory': 'gunkan'  
            },
            {
                'indicator': 144,
                'name': 'Gunkan Ebi (2 Unid.)',
                'description': 'Arroz envuelto de hoja de pepino con gambas cocidas y mayonesa.',
                'image': ImageHost + 'assert/imagenew/gunkan/gamba.webp',
                'alergenos': [
                    alergenosEnum.moluscos,
                    alergenosEnum.huevos
                ], 
                'picante': false,
                'subcategory': 'gunkan'  
            },  
            {
                'indicator': 145,
                'name': 'Gunkan Salmon y pepino (2 Unid.)',
                'description': 'Arroz envuelto de hoja de pepino con salmón spicy.',
                'image': ImageHost + 'assert/imagenew/gunkan/salmon-pepino.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.huevos
                ], 
                'picante': true,
                'subcategory': 'gunkan'  
            }, 
            {
                'indicator': 146,
                'name': 'Rollos de Salmón (2 Unid.)',
                'description': 'Rollo de salmón con rucula, papaya y salsa passion fruit.',
                'image': ImageHost + 'assert/imagenew/gunkan/rollo-salmon.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.gluten, 
                    alergenosEnum.cacahuetes
                ], 
                'picante': false,
                'subcategory': 'gunkan'  
            },                                  
            {
                'indicator': 147,
                'name': 'Gunkan Soy Spicy Salmón (2 Unid.)',
                'description': 'Arroz envuelto en hojaldres de soja, salmón spicy, tobiko, almendras y mahonesa',
                'image': ImageHost + 'assert/gunkan/gunkan-soy-salmon.png',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.gluten, 
                    alergenosEnum.cacahuetes, 
                    alergenosEnum.sesamo,
                    alergenosEnum.huevos
                ], 
                'picante': true,
                'subcategory': 'gunkan'  
            }, 
            {
                'indicator': 148,
                'name': 'Gunkan Soy Spicy Atún (2 Unid.)',
                'description': 'Arroz envuelto en hojaldres de soja, atún spicy, tobiko, pistacho y mahonesa.',
                'image': ImageHost + 'assert/gunkan/gunkan-soy-atun.png',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.gluten, 
                    alergenosEnum.cacahuetes, 
                    alergenosEnum.sesamo,
                    alergenosEnum.huevos

                ], 
                'picante': true,
                'subcategory': 'gunkan'  
            }, 
            {
                'indicator': 149,
                'name': 'Gunkan Soy Spicy Ebi (2 Unid.)',
                'description': 'Arroz envuelto en hojaldres de soja, tartar de gambas cocidas y algas picantes.',
                'image': ImageHost + 'assert/gunkan/gunkan-soy-ebi.png',
                'alergenos': [
                    alergenosEnum.crustaceos,
                    alergenosEnum.gluten, 
                    alergenosEnum.sesamo, 
                    alergenosEnum.frutos_secos,

                ], 
                'picante': true,
                'subcategory': 'gunkan'  
            },  
            {
                'indicator': 150,
                'name': 'Temaki Sake',
                'description': 'Salmón, aguacate, sesamo con mayonesa japonesa.',
                'image': ImageHost + 'assert/imagenew/temaki/salmon.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.gluten, 
                ], 
                'picante': true,
                'subcategory': 'temaki'  
            }, 
            {
                'indicator': 151,
                'name': 'Temaki Maguro',
                'description': 'Atún, aguacate, masago, salsa kimochi',
                'image': ImageHost + 'assert/imagenew/temaki/atun.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                    alergenosEnum.gluten, 

                ], 
                'picante': true,
                'subcategory': 'temaki'  
            },
            {
                'indicator': 152,
                'name': 'Temaki Ebi fry',
                'description': 'Ebi frito, boniato frito, salsa de chile',
                'image': ImageHost + 'assert/imagenew/temaki/ebifry.webp',
                'alergenos': [
                    alergenosEnum.moluscos,
                    alergenosEnum.gluten

                ], 
                'picante': true,
                'subcategory': 'temaki' 
            },
            {
                'indicator': 153,
                'name': 'Temaki Surimi',
                'description': 'Surimi, aguacate, pepino, mayonesa con sesamo.',
                'image': ImageHost + 'assert/imagenew/temaki/surimi.webp',
                'alergenos': [
                    alergenosEnum.crustaceos,
                    alergenosEnum.sesamo, 
                    alergenosEnum.huevos,

                ], 
                'picante': true,
                'subcategory': 'temaki' 
            }, 
            {
                'indicator': 154,
                'name': 'Temaki Pato',
                'description': 'Pato, pepino, cebollino, mayonesa spicy y salsa teriyaki',
                'image': ImageHost + 'assert/imagenew/temaki/pato.webp',
                'alergenos': [
                    alergenosEnum.huevos, 
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten,

                ], 
                'picante': true,
                'subcategory': 'temaki' 
            },
            {
                'indicator': 155,
                'name': 'Tartar de Atún',
                'description': '',
                'image': ImageHost + 'assert/imagenew/tartar/atun.webp',
                'alergenos': [
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten,
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'limit': '*1 ración/pers.',
                'subcategory': 'otros' 
            }, 
            {
                'indicator': 156,
                'name': 'Tartar de Salmón',
                'description': '',
                'image': ImageHost + 'assert/imagenew/tartar/salmon.webp',
                'alergenos': [
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten,
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'subcategory': 'otros' 
            },
            {
                'indicator': 160,
                'name': 'Tataki de Atún',
                'description': '',
                'image': ImageHost + 'assert/imagenew/tataki/atun.webp',
                'alergenos': [
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten,
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'limit': '*2 ración/pers.',
                'subcategory': 'otros' 
            }, 
            {
                'indicator': 161,
                'name': 'Tataki de Salmón',
                'description': '',
                'image': ImageHost + 'assert/imagenew/tataki/salmon.webp',
                'alergenos': [
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten,
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'limit': '*2 ración/pers.',
                'subcategory': 'otros' 
            }, 
            {
                'indicator': 162,
                'name': 'Tataki de Ternera',
                'description': '',
                'image': ImageHost + 'assert/imagenew/tataki/ternera.webp',
                'alergenos': [
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten,
                    alergenosEnum.pescado,
                ], 
                'picante': false,
                'subcategory': 'otros' 
            },                                                                                      
        ],
    },
    {
        'category': 'Vapor',
        'items': [  
            {
                'indicator': 200,
                'name': 'Xiaolongbao',
                'description': 'Empanadilla rellena de carne al vapor. (3 unid.)',
                'image': ImageHost + 'assert/imagenew/vapor/xiaolongbao.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.gluten,
                    alergenosEnum.huevos,
                    alergenosEnum.lacteos,
                ], 
                'picante': false
            },           
            /*{
                'indicator': 201,
                'name': 'Gyozas Langostinos',
                'description': 'Gyozas de langostinos  (3 unid.)',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/21-Gyozas-de-langostino-1-scaled-370x370.jpg',
                'image': ImageHost + 'assert/vapor/gyoza-langostino-vapor.webp',
                'alergenos': [
                    alergenosEnum.crustaceos,
                    alergenosEnum.soja,
                ], 
                'picante': false
            },*/
            {
                'indicator': 202,
                'name': 'Gyozas',
                'description': 'Gyozas de carne y verdura  (3 unid.)',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/19-Gyozas-1-scaled-370x370.jpg',
                'image': ImageHost + 'assert/vapor/gyoza-salteado.webp',               
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.sesamo,
                    alergenosEnum.soja,
                    alergenosEnum.apio
                ], 
                'picante': false
            },
            {
                'indicator': 203,
                'name': 'Gyozas de verduras',
                'description': 'Gyozas de verdura  (3 unid.)',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/19-Gyozas-1-scaled-370x370.jpg',
                'image': ImageHost + 'assert/imagenew/vapor/gyoza-verdura.webp',               
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.sesamo,
                    alergenosEnum.soja,
                    alergenosEnum.apio
                ], 
                'picante': false
            },                   
            {
                'indicator': 204,
                'name': 'Sau mai',
                'description': 'Sau mai con carne, zanahoria, col, cebolla, setas y bambu.  (3 unid.)',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/20-Sau-mai-1-scaled-370x370.jpg',
                'image': ImageHost + 'assert/imagenew/vapor/sau-mai.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                ], 
                'picante': false
            }
        ], 
    },
    {
        'category': 'Fritos',
        'items': [
            {
                'indicator': 250,
                'name': 'Panecillos',
                'description': 'Harina de trigo, leche (2 unid.)',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/26-Panecillo-1-scaled-370x370.jpg',
                'image': ImageHost + 'assert/frito/panecillos.png',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.lacteos
                ], 'picante': false
            },
            {
                'indicator': 249,
                'name': 'Wantun fritos',
                'description': 'Wantun fritos con carne (3 unid.)',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/25-Wantun-frito-1-scaled-370x370.jpg',
                'image': ImageHost + 'assert/frito/wantun.png',
                'alergenos': [
                    alergenosEnum.gluten
                ], 'picante': false
            },
           {
                'indicator': 251,
                'name': 'Gyoza de Pollo fritos ',
                'description': 'Gyoza de Pollo fritos (3 unid.)',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/25-Wantun-frito-1-scaled-370x370.jpg',
                'image': ImageHost + 'assert/frito-new/gyoza-pollo-frito.webp',
                'alergenos': [
                    alergenosEnum.gluten
                ], 'picante': false
            },        
            {
                'indicator': 252,
                'name': 'Takoyaki',
                'description': 'Harina, pulpo, huevo, pasta kataifi  (2 unid.)',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/39-Takoyaki-04-scaled-370x370.jpg',
                'image': ImageHost + 'assert/imagenew/frito/takoyaki.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.moluscos,
                    alergenosEnum.altramuz
                ], 
                'picante': false
            },
            {
                'indicator': 253,
                'name': 'Japobravas',
                'description': 'Patatas tempurizadas con alioli de wasabi y salsa japobrava.',
                'image': ImageHost + 'assert/imagenew/frito/japobravas.webp',
                'alergenos': [
                    alergenosEnum.huevos,
                    alergenosEnum.sesamo
                ], 
                'picante': false
            },
            {
                'indicator': 254,
                'name': 'Harumaki Rollito Verdura',
                'description': 'Verdura, huevo  (1 unid.)',
                'image': ImageHost + 'assert/frito-new/rollito-japones.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.altramuz,
                    alergenosEnum.soja
                ], 'picante': false
            },
            /*{
                'indicator': 255,
                'name': 'Rollito vietnamita',
                'description': 'Rollito vietnamitas.  (1 unid.)',
                'image': ImageHost + 'assert/frito/rollo-vietnamita-1.png',
                'alergenos': [
                    alergenosEnum.gluten
                ], 
                'picante': false
            },*/   
            {
                'indicator': 256,
                'name': 'Katsupollo',
                'description': 'Pollo frito al estilo katsu, pollo, huevo y harina',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/28-Katsupollo-02-scaled-370x370.jpg',
                'image': ImageHost + 'assert/imagenew/frito/katsupollo.webp',
                'alergenos': [
                    alergenosEnum.gluten
                ], 'picante': false
            },
            {
                'indicator': 257,
                'name': 'Katsu Lomo con queso',
                'description': 'Lomo con queso frito al estilo katsu',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/29-Katsu-lomo-con-queso-01-scaled-370x370.jpg',
                'image': ImageHost + 'assert/frito/Katsulomo.png',
                'alergenos': [
                    alergenosEnum.gluten
                ], 'picante': false
            },                                      
            {
                'indicator': 258,
                'name': 'Patatas fritas',
                'description': 'Patatas fritas',
                'image': ImageHost + 'assert/imagenew/frito/patatas.webp',
                'alergenos': [
                ], 'picante': false
            },
            {
                'indicator': 259,
                'name': 'Tempura langostinos (2 unid.)',
                'description': 'Tempura de Langostinos',
                'image': ImageHost + 'assert/imagenew/frito/tempura-gamba.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.crustaceos
                ], 'picante': false
            },
            {
                'indicator': 260,
                'name': 'Tempura verdura',
                'description': 'Tempura de verduras',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/29-Katsu-lomo-con-queso-01-scaled-370x370.jpg',
                'image': ImageHost + 'assert/imagenew/frito/tempura-verdura.webp',                                
                'alergenos': [
                    alergenosEnum.gluten
                ], 'picante': false
            },
            {
                'indicator': 261,
                'name': 'Alitas de Pollo Barbacoa teriyaki',
                'description': 'Alitas de Pollo con salsa barbacoa teriyaki',
                //'image': 'https://kyoka.es/wp-content/uploads/2021/01/29-Katsu-lomo-con-queso-01-scaled-370x370.jpg',
                'image': ImageHost + 'assert/frito-new/alitas-pollo.webp',                                
                'alergenos': [
                    alergenosEnum.gluten
                ], 'picante': false
            }
        ], 
    },
    {
        'category': 'Plancha',
        'items': [
            {
                'indicator': 300,
                'name': 'Ooebi no shioaki',
                'description': 'Gambón a la plancha con salsa ajo y perijil. (3 unid.)',                
                'image': ImageHost + 'assert/imagenew/plancha/gambon.webp',   
                'alergenos': [
                    alergenosEnum.crustaceos,
                ], 'picante': false
            },
            {
                'indicator': 301,
                'name': 'Ebi Kushi',
                'description': 'Pincho de Gambas (2 unid.)',
                'image': ImageHost + 'assert/imagenew/plancha/pincho-gamba.webp',
                'alergenos': [
                    alergenosEnum.crustaceos,
                    alergenosEnum.sesamo
                ], 'picante': false
            },
            {
                'indicator': 302,
                'name': 'Yaki Tori',
                'description': 'Pincho de Pollo con salsa teriyaki (2 unid.)',
                'image': ImageHost + 'assert/imagenew/plancha/pincho-pollo.webp',
                'alergenos': [
                    alergenosEnum.soja,
                ], 'picante': false
            },
            {
                'indicator': 303,
                'name': 'Sake Teppanyaki',
                'description': 'Salmón a la plancha',
                'image': ImageHost + 'assert/imagenew/plancha/salmon.webp',
                'alergenos': [
                    alergenosEnum.pescado,
                ], 'picante': false
            },
            {
                'indicator': 304,
                'name': 'Esparragos a la plancha',
                'description': 'Esparragos a la plancha',
                'image': ImageHost + 'assert/imagenew/plancha/esparrago.webp',
                'alergenos': [
                ], 'picante': false
            },            
            {
                'indicator': 305,
                'name': 'Sepia a la plancha',
                'description': 'Sepia a la plancha',
                'image': ImageHost + 'assert/plancha/sepia.png',
                'alergenos': [
                    alergenosEnum.moluscos
                ], 'picante': false
            },
            {
                'indicator': 306,
                'name': 'Ternera a la plancha',
                'description': 'Ternera a la plancha',
                'image': ImageHost + 'assert/imagenew/plancha/entrecot.webp',
                'alergenos': [
                ], 'picante': false
            },
            /*{
                'indicator': 307,
                'name': 'Vieras',
                'description': 'Vieras a la plancha (2 Unid.)',
                'image': ImageHost + 'assert/plancha/viera.png',
                'alergenos': [
                ], 'picante': false
            }
            */
           {
                'indicator': 308,
                'name': 'Entraña con salsa chumichurri japonesa',
                'description': 'Entraña con chumichurri japonesa',
                'image': ImageHost + 'assert/plancha/entranya.webp',
                'alergenos': [
                ], 
                'picante': false
            }, 
            {
                'indicator': 309,
                'name': 'Patas de araña a la plancha',
                'description': 'Patas de araña a la plancha',
                'image': ImageHost + 'assert/plancha/patas-aranya-plancha.webp',
                'alergenos': [
                    alergenosEnum.crustaceos
                ], 
                'picante': false,
                'limit': '*1 ración/pers.'
            }, 
            /*{
                'indicator': 310,
                'name': 'Pulpitos a la plancha',
                'description': 'Pulpitos a la plancha',
                'image': ImageHost + 'assert/plancha/pulpito-plancha.webp',
                'alergenos': [
                    alergenosEnum.moluscos
                ], 
                'picante': false
            },*/ 
            {
                'indicator': 311,
                'name': 'Almeja a la plancha',
                'description': 'Almeja a la plancha',
                'image': ImageHost + 'assert/plancha/almeja-plancha.webp',
                'alergenos': [
                    alergenosEnum.moluscos
                ], 
                'picante': false
            },
            {
                'indicator': 312,
                'name': 'Navajas a la plancha',
                'description': 'Navajas a la plancha',
                'image': ImageHost + 'assert/plancha/navaja.webp',
                'alergenos': [
                    alergenosEnum.moluscos
                ], 
                'picante': false
            }                         
        ],
    },
    {
        'category': 'Calientes',
        'items': [
            {
                'indicator': 350,
                'name': 'Fideos de Arroz',
                'description': 'Fideos de Arroz',
                'image': ImageHost + 'assert/caliente/fideos-new.webp',
                'alergenos': [
                    alergenosEnum.huevos, 
                    alergenosEnum.moluscos
                ], 'picante': false
            },
            {
                'indicator': 351,
                'name': 'Yakisoba',
                'description': 'Yakisoba',
                'image': ImageHost + 'assert/caliente/yakisoba-new.webp',
                'alergenos': [
                    alergenosEnum.huevos, 
                    alergenosEnum.gluten
                ], 'picante': false
            },
            {
                'indicator': 352,
                'name': 'Udon',
                'description': 'Udon',
                'image': ImageHost + 'assert/imagenew/caliente/udon.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.huevos
                ], 'picante': false
            },
            {
                'indicator': 353,
                'name': 'Arroz Pollo',
                'description': 'Arroz fritos de Pollo',
                'image': ImageHost + 'assert/caliente/arroz-pollo.webp',
                'alergenos': [
                    alergenosEnum.huevos, 
                    alergenosEnum.gluten
                ], 'picante': false
            },
            {
                'indicator': 354,
                'name': 'Arroz Verduras',
                'description': 'Arroz fritos con verduras variadas',
                'image': ImageHost + 'assert/imagenew/caliente/arroz-verdura.webp',
                'alergenos': [
                    alergenosEnum.huevos,
                    alergenosEnum.soja,
                    alergenosEnum.gluten
                ], 'picante': false
            },
            {
                'indicator': 355,
                'name': 'Spaguetti de Soja',
                'description': 'Spaguetti de Soja fritos',
                'image': ImageHost + 'assert/caliente/fideos-soja.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.huevos
                ], 'picante': false
            },
            /*{
                'indicator': 356,
                'name': 'Pollo Teriyaki',
                'description': 'Pollo con salsa Teriyaki',
                'image': ImageHost + 'assert/caliente/pollo-teriyaki.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten
                ], 'picante': false
            },*/
            {
                'indicator': 357,
                'name': 'Pollo con setas Shimeji',
                'description': 'Pollo con setas Shimeji',
                'image': ImageHost + 'assert/caliente/pollo-shimeji.webp',
                'alergenos': [
                    alergenosEnum.soja, 
                    alergenosEnum.gluten,
                ], 'picante': true
            },            
            /*{
                'indicator': 358,
                'name': 'Pollo Sake',
                'description': 'Pollo, sake, salsa soja',
                'image': ImageHost + 'assert/caliente/pollo-sake.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.sesamo, 
                    alergenosEnum.gluten
                ], 'picante': false
            },
            */
            {
                'indicator': 359,
                'name': 'Pollo al curry',
                'description': 'Pollo al sabor curry',
                'image': ImageHost + 'assert/caliente/pollo-curry-new.webp',
                'alergenos': [
                    alergenosEnum.moluscos,
                ], 'picante': false
            },            
            {
                'indicator': 360,
                'name': 'Ternera Teriyaki',
                'description': 'Ternera con salsa Teriyaki, cebolla, pimiento y puerro',
                'image': ImageHost + 'assert/caliente/ternera-teriyaki-new.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.sesamo
                ], 'picante': false
            },
            {
                'indicator': 361,
                'name': 'Ternera Cebolla Tiernas',
                'description': 'Ternera con Cebolla Tiernas',
                'image': ImageHost + 'assert/caliente/ternera-cebollino-new.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.sesamo
                ], 'picante': false
            },            
            /*{
                'indicator': 362,
                'name': 'Ternera Sake',
                'description': 'Ternera, sake, salsa soja',
                'image': ImageHost + 'assert/caliente/ternera-sake.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.sesamo
                ], 'picante': false
            },
            */            
            {
                'indicator': 363,
                'name': 'Gambas Sal y Pimienta',
                'description': 'Gambas salteada con sal y pimienta.',
                'image': ImageHost + 'assert/caliente/gamba-sal-pimienta-new.webp',
                'alergenos': [
                    alergenosEnum.moluscos,
                ], 'picante': false
            },
            /*{
                'indicator': 364,
                'name': 'Marisco mixto salteado',
                'description': 'Marisco mixto salteado.',
                'image': ImageHost + 'assert/caliente/marisco-mixto-new.webp',
                'alergenos': [
                    alergenosEnum.gluten,
                    alergenosEnum.moluscos,
                ], 'picante': false
            },*/
            {
                'indicator': 365,
                'name': 'Pollo con Chili-Miel',
                'description': 'Pollo salteado con salsa chili y miel.',
                'image': ImageHost + 'assert/caliente/pollo-chili-miel.webp',
                'alergenos': [
                    alergenosEnum.sesamo
                ], 'picante': false
            },
            {
                'indicator': 366,
                'name': 'Almejas con salsa',
                'description': 'Almejas salteadas con salsa de la casa.',
                'image': ImageHost + 'assert/caliente/almeja-salsa.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.moluscos
                ], 'picante': false
            },
            {
                'indicator': 367,
                'name': 'Padthai ',
                'description': 'Padthai',
                'image': ImageHost + 'assert/caliente/padthai-propia.webp',
                'alergenos': [
                    alergenosEnum.soja,
                    alergenosEnum.gluten
                ], 'picante': false
            },
            {
                'indicator': 368,
                'name': 'Verdura al wok',
                'description': 'Col tierna, puerros y setas',
                'image': ImageHost + 'assert/caliente/verdura-wok.webp',
                'alergenos': [
                    alergenosEnum.gluten
                ], 'picante': false
            }, 
            {
                'indicator': 369,
                'name': 'Pollo black bean',
                'description': 'Pollo con verduras y salsa de judías pintas',
                'image': ImageHost + 'assert/caliente/pollo-blackbean.webp',
                'alergenos': [
                    alergenosEnum.gluten
                ], 'picante': false
            },
            {
                'indicator': 370,
                'name': 'Arroz con marisco',
                'description': 'Arroz, gamba, cangrejo, guisantes, maíz y zanahoria',
                'image': ImageHost + 'assert/caliente/arroz-marisco-new.webp',
                'alergenos': [

                    alergenosEnum.gluten,
                    alergenosEnum.huevos,
                    alergenosEnum.crustaceos
                ], 'picante': false
            }, 
            {
                'indicator': 371,
                'name': 'Tallarines frescos',
                'description': 'Tallarines, ternera, verduras y salsa de soja',
                'image': ImageHost + 'assert/caliente/tallarines-fresco.webp',
                'alergenos': [

                    alergenosEnum.gluten,
                    alergenosEnum.huevos,
                    alergenosEnum.soja
                ], 'picante': false
            },
            {
                'indicator': 372,
                'name': 'Chow mein',
                'description': 'Pasta con verduras, tiras de pollo y salsa de soja',
                'image': ImageHost + 'assert/caliente/chow-mein.webp',
                'alergenos': [

                    alergenosEnum.gluten,
                    alergenosEnum.huevos,
                    alergenosEnum.soja
                ], 'picante': false
            },                                     
        ], 
    }            
];


export const useNightMenuData = (category: 'Entrante'|'Sushi'|'Calientes'|'Fritos'|'Vapor'|'Plancha'|'Bebida'|'Postre') => {
    const [items, setItems] = React.useState<IItemInterface[]>([]);
  
    useEffect(() => {
    
        for (let i = 0; i < menu.length; i++) {
            if (menu[i].category === category) {
                setItems(menu[i].items);
            }
        }
    }, [category]);


    return items;
}

export const useNightMenuDataWithSubCategory = (category: 'Entrante'|'Sushi'|'Calientes'|'Fritos'|'Vapor'|'Plancha'|'Bebida'|'Postre', subcategory: string) => {

    const data = useNightMenuData(category)

    return data.filter(item => item.subcategory != undefined && item.subcategory === subcategory)
}